<template>
  <a-modal
    :visible="visible"
    :title="isEdit ? $t('attach_form_edit_folder') : $t('attach_form_new_folder')"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :maskClosable="false"
    :confirmLoading="loading"
    centered
    destroyOnClose
  >
    <a-form-model
      ref="folderForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 15 }"
    >
      <!-- <a-form-model-item :label="$t('attach_form_dir_type')" prop="type">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="formData.type"
        >
          <a-select-option
            :value="typeItem.value"
            v-for="typeItem in attachTypeList"
            :key="typeItem.value"
          >
            {{ typeItem.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item> -->

      <a-form-model-item :label="$t('attach_form_folder_name')" prop="name">
        <a-input v-model="formData.name" :placeholder="$t('attach_form_folder_name_placeholder')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('attach_form_folder_read_permission')" prop="readLevel">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="formData.readLevel"
          :placeholder="$t('attach_form_read_permission_placeholder')"
          allowClear
        >
          <a-select-option :value="item.value" v-for="item in readList" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('attach_form_folder_write_permission')" prop="writeLevel">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="formData.writeLevel"
          :placeholder="$t('attach_form_write_permission_placeholder')"
          allowClear
        >
          <a-select-option :value="item.value" v-for="item in writeList" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('attach_form_folder_desc')" prop="intro">
        <a-textarea
          v-model="formData.intro"
          :placeholder="$t('attach_form_folder_desc_placeholder')"
          :rows="4"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import attachConfig from '@/views/attach/mixins/config';
export default {
  mixins: [attachConfig],
  name: 'FolderDialog',
  data() {
    return {
      visible: false,
      loading: false,
      isEdit: false,
      formData: {
        id: 0,
        type: 0,
        name: undefined,
        intro: '',
        icon: '',
        readLevel: 5,
        writeLevel: 5,
      },

      rules: {
        name: [
          {
            required: true,
            message: this.$t('attach_form_folder_name_placeholder'),
            trigger: 'blur',
          },
        ],
        readLevel: [
          {
            required: true,
            message: this.$t('attach_form_read_permission_placeholder'),
            trigger: 'change',
          },
        ],
        writeLevel: [
          {
            required: true,
            message: this.$t('attach_form_write_permission_placeholder'),
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    // 显示文件夹弹窗
    show(data) {
      this.visible = true;
      if (data) {
        this.isEdit = true;
        // this.formData = { ...data };
        for (const key in this.formData) {
          this.formData[key] = data[key];
        }
      } else {
        this.isEdit = false;
        this.resetForm();
      }
    },

    // 取消按钮处理
    handleCancel() {
      this.visible = false;
      this.resetForm();
    },

    // 提交表单处理
    handleSubmit() {
      this.$refs.folderForm.validate(valid => {
        if (valid) {
          this.loading = true;
          console.log(this.formData);
          this.$emit('submit', this.formData);
        }
      });
    },

    // 重置表单
    resetForm() {
      this.$refs.folderForm?.resetFields();
      this.formData = {
        id: 0,
        icon: 0, // 目录图标作为默认值
        type: 0,
        name: '',
        readLevel: 5,
        writeLevel: 5,
        intro: '',
      };
      this.isEdit = false;
    },
  },
};
</script>
